export default __webpack_public_path__ + "static/media/pic.830fc26c.svg";